import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a0c5d2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cross-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "data-contianer" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("账单明细")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("调账明细")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("账单确认")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("账单确认")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("确认函签署")
const _hoisted_8 = { style: {"margin":"0 8px","font-weight":"normal"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_DefaultOptionSelect = _resolveComponent("DefaultOptionSelect")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_ReportTable = _resolveComponent("ReportTable")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_AdminTableLayout = _resolveComponent("AdminTableLayout")!
  const _component_ElImageViewer = _resolveComponent("ElImageViewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AdminTableLayout, {
      formData: _ctx.formData,
      rules: _ctx.serarchRules,
      formLabelWidth: 120,
      searchDisabled: _ctx.loading,
      onSearch: _ctx.onSearchHandle
    }, {
      "search-info": _withCtx(() => [
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "结款日期",
              prop: "time"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_DatePicker, {
                    type: "monthrange",
                    modelValue: _ctx.formData.time,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.time) = $event)),
                    format: "YYYY-MM",
                    valueFormat: "YYYYMM",
                    clearable: false,
                    onCalendarChange: _ctx.handleCalendarChange,
                    onPick: _ctx.handleCalendarChange
                  }, null, 8, ["modelValue", "onCalendarChange", "onPick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "网点确认状态",
              "label-width": 120
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DefaultOptionSelect, {
                  valueKey: "value",
                  labelKey: "key",
                  defaultOptions: _ctx.siteAffirmStatus,
                  modelValue: _ctx.formData.siteAffirmStatus,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.siteAffirmStatus) = $event))
                }, null, 8, ["defaultOptions", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "账单状态",
              "label-width": "100px",
              prop: "affirmStatus"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DefaultOptionSelect, {
                  valueKey: "value",
                  labelKey: "key",
                  defaultOptions: _ctx.affirmStatus,
                  modelValue: _ctx.formData.affirmStatus,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.affirmStatus) = $event))
                }, null, 8, ["defaultOptions", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "客户名称",
              prop: "customerId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DefaultOptionSelect, {
                  valueKey: "value",
                  labelKey: "key",
                  clearable: false,
                  defaultOptions: _ctx.accountWithSite,
                  modelValue: _ctx.formData.customerId,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.customerId) = $event))
                }, null, 8, ["defaultOptions", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "网点名称",
              prop: "siteId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DefaultOptionSelect, {
                  valueKey: "value",
                  labelKey: "key",
                  clearable: false,
                  defaultOptions: _ctx.siteList,
                  modelValue: _ctx.formData.siteId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.siteId) = $event))
                }, null, 8, ["defaultOptions", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "项目客户",
              prop: "contractProjectId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DefaultOptionSelect, {
                  valueKey: "id",
                  labelKey: "customerName",
                  defaultOptions: _ctx.contractProjectList,
                  modelValue: _ctx.formData.contractProjectId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.contractProjectId) = $event))
                }, null, 8, ["defaultOptions", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      "content-table": _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_ReportTable, {
          loading: _ctx.loading,
          emptyText: "暂无账单",
          tableData: _ctx.tableData,
          showTableColumn: _ctx.showTableColumn,
          templateRenders: {
          actions: _ctx.actionsHandle,
        }
        }, {
          actions: _withCtx(({ row }) => [
            _createVNode(_component_el_link, {
              type: "primary",
              style: {"margin-right":"5px"},
              onClick: ($event: any) => (_ctx.handleBillDetail(row))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_link, {
              type: "primary",
              style: {"margin-right":"5px"},
              onClick: ($event: any) => (_ctx.handleAdjustDetail(row))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (row.siteCheckStatus == 0)
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 0,
                  type: "primary",
                  style: {"margin-right":"5px"},
                  disabled: "",
                  onClick: ($event: any) => (_ctx.handleSure(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (row.siteCheckStatus == 1 && row.customerCheckStatus != 1)
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 1,
                  type: "primary",
                  style: {"margin-right":"5px"},
                  onClick: ($event: any) => (_ctx.handleSure(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (
              row.siteCheckStatus == 1 &&
              row.customerCheckStatus == 1 &&
              row.accountCycle == 3 &&
              !row.signatureAddress
            )
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 2,
                  type: "primary",
                  style: {"margin-right":"5px"},
                  onClick: ($event: any) => (_ctx.handleSureSign(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading", "tableData", "showTableColumn", "templateRenders"])
      ]),
      "foot-pagination": _withCtx(() => [
        _createVNode(_component_el_pagination, {
          "popper-class": "pagination-popper",
          class: "system-pagination",
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.totalNum,
          "page-sizes": [..._ctx.pageSizeList, 1000, 2000, 5000],
          "current-page": _ctx.pageNum,
          "onUpdate:current-page": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pageSize) = $event)),
          onCurrentChange: _ctx.currentPageChangeHandle,
          onSizeChange: _ctx.sizeChangeHandle
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_8, "第 " + _toDisplayString(_ctx.pageNum) + " 页", 1)
          ]),
          _: 1
        }, 8, ["total", "page-sizes", "current-page", "page-size", "onCurrentChange", "onSizeChange"])
      ]),
      _: 1
    }, 8, ["formData", "rules", "searchDisabled", "onSearch"]),
    (_ctx.preview.show)
      ? (_openBlock(), _createBlock(_component_ElImageViewer, {
          key: 0,
          "url-list": _ctx.preview.urls,
          onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
          onClose: _ctx.onClosePreview
        }, null, 8, ["url-list", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}